const sleep = (ms = 0) => {
	return new Promise(r => setTimeout(r, ms));
};

export default sleep;
